import React from 'react'
import { ButtonBase } from '@/components/common'

interface Props {
  label: string
  showItem: boolean
  onClick: () => void
}

const MenuItem: React.FC<Props> = ({ label, showItem, onClick }) => {
  if (!showItem) return null

  return (
    <ButtonBase className="text-sm py-[11px] leading-tight" onClick={onClick}>
      {label}
    </ButtonBase>
  )
}

export default MenuItem
